import { render, staticRenderFns } from "./PICDistribuzione.vue?vue&type=template&id=44333b1a&scoped=true"
import script from "./PICDistribuzione.vue?vue&type=script&lang=js"
export * from "./PICDistribuzione.vue?vue&type=script&lang=js"
import style0 from "./PICDistribuzione.vue?vue&type=style&index=0&id=44333b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44333b1a",
  null
  
)

export default component.exports